import React from 'react';
import { buildRow, getLabel, showModalNoOutsideClick } from '../../util/FormatUtil';
import { getConvertedValue } from '../resultReports/helpers/utils';
import { sweetalert } from '../../App';
import SamplesAPI from '../../network/SamplesAPI';
import ServicesAPI from '../../network/ServicesAPI';
import Overlay from '../Overlay';
import { ReportSelectModal } from './ReportSelectModal';
import { isInTieredGroup } from '../../types/Service';
import NetworkUtil from '../../network/NetworkUtil';
import { RendererPickerModal } from './RendererPickerModal';

interface ViewTestInfoModalState {
  showLoading: boolean;
  pdfDataURL;
  availableRenderers: { label: string; value: string; description?: string }[];
  showRendererPicker: boolean;
}

interface ViewTestInfoModalProps {
  selectedSample;
  tests;
  results;
  services?;
  getResultsButtonBoolean;
}

class ViewTestInfoModal extends React.Component<ViewTestInfoModalProps, ViewTestInfoModalState> {
  public static ID = 'ViewTestInfo';
  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      pdfDataURL: '',
      availableRenderers: [],
      showRendererPicker: false,
    };
    this.downloadDTCReport = this.downloadDTCReport.bind(this);
  }

  componentDidMount() {
    // Bootstrap traps focus inside the modal via a document-level
    // focusin.modal handler. That handler intercepts mousedown events
    // on elements outside the modal DOM (like react-select menus
    // portaled to document.body), so clicking the select body does
    // nothing — only the arrow toggle fires. Removing it when the
    // modal is shown restores normal interaction.
    $(`#${ViewTestInfoModal.ID}`).on('shown.bs.modal', function () {
      $(document).off('focusin.modal');
    });

    ServicesAPI.getRenderers().then((data) => {
      if (data.success && data.renderers) {
        this.setState({
          availableRenderers: data.renderers.map((r) => ({
            label: r.displayName || r.name,
            value: r.name,
            description: r.description,
          })),
        });
      }
    }).catch(() => { /* non-fatal — picker just stays empty, button uses Service default */ });
  }

    downloadDTCReport(rendererName: string | null) {
      this.setState({ showLoading: true }, async () => {
            const body: any = { reqNum: this.props.selectedSample?.ReqNum };
            if (rendererName) body.renderer = rendererName;
            await NetworkUtil.downloadPDF(
              '/api/admin/patient/downloadDirectToConsumerReport',
              `${this.props.selectedSample?.PatientLastName}, ${this.props.selectedSample?.PatientFirstName})-Oral-Balance-Report.pdf`,
              body,
              true
            );
            this.setState({ showLoading: false });
      })
    }

    // Computes the set of renderers the user can pick for the given
    // service: the intersection of service.AllowedRenderers with the
    // registry's available renderers.
    getRendererPickerOptions(service: any): { label: string; value: string }[] {
      if (!service || !service.AllowedRenderers) return [];
      let allowed: string[] = [];
      try {
        const parsed = typeof service.AllowedRenderers === 'string'
          ? JSON.parse(service.AllowedRenderers)
          : service.AllowedRenderers;
        allowed = Array.isArray(parsed) ? parsed : [];
      } catch { allowed = []; }
      if (allowed.length === 0) return [];
      return this.state.availableRenderers.filter((r) => allowed.includes(r.value));
    }

  openPDFNewTab() {
    let sampleService =
      this.props.services && this.props.selectedSample
        ? this.props.services.find((f) => f.ID === this.props.selectedSample.ServiceID)
        : null;
    if (!sampleService) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Could not create report at this time' });
    }
    let reportType = sampleService.ReportType;
    if (!reportType) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Could not create report at this time' });
    }
    // New-pipeline dispatch: any service that has a registered renderer
    // configured (default or allowed list) routes through the
    // RendererPickerModal / direct-download flow, regardless of
    // ReportType. ReportType == 5 is no longer the gate — only the
    // presence of renderer config is.
    const hasNewPipelineRenderer = !!(
      sampleService.ReportRenderer ||
      (sampleService.AllowedRenderers && String(sampleService.AllowedRenderers).length > 0)
    );
    if (hasNewPipelineRenderer) {
      const pickerOptions = this.getRendererPickerOptions(sampleService);
      if (pickerOptions.length > 0) {
        this.setState({ showRendererPicker: true });
      } else {
        this.downloadDTCReport(null);
      }
    }
    else if (reportType >= 3) {
      this.setState({ showLoading: true }, async () => {
        let reason;
        try {
          // const response = await SamplesAPI.get6PlexPDFReport(this.props.selectedSample.ID);
          // reason = response && response.reason ? response.reason : '';
          // let data = await response.arrayBuffer();
          // const blob = new Blob([data], {type: 'application/pdf'});
          // const url = URL.createObjectURL(blob)
          // window.open(url, '_blank')
          showModalNoOutsideClick(ReportSelectModal.ID);
          this.setState({ showLoading: false });
        } catch (e) {
          this.setState({ showLoading: false });
          return sweetalert.fire({ icon: 'error', title: '', text: reason });
        }
      });
    }
  }

  render() {
    let testAndResultsArray = [];
    let tempMap;
    let tempIDs;
    let hasAdditionalResultValue = false;
    let noTests = false;
    let selectedService =
      this.props.services && this.props.services.length > 0 && this.props.selectedSample
        ? this.props.services.find((f) => f.ID === this.props.selectedSample.ServiceID)
        : null;
    let isEssentialOrComprehensive;
    let isDTC;
    if (selectedService && selectedService.ReportType == 5) {
      isDTC = true;
    }

    if (this.props.selectedSample.TestIDs) {
      tempIDs = JSON.parse(this.props.selectedSample.TestIDs);
    }


    if (selectedService && this.props.services) {
      isEssentialOrComprehensive = isInTieredGroup(selectedService, this.props.services);
    }

    if (this.props.selectedSample.TestsAndResultsMap) {
      tempMap = JSON.parse(this.props.selectedSample.TestsAndResultsMap);

      // For subset services (those with a parent), only show tests that were
      // actually ordered for this sample. Parents/standalones show full map.
      if (selectedService && isEssentialOrComprehensive) {
        tempMap = selectedService.UpgradesToServiceID
          ? tempMap.filter((item) => tempIDs.includes(item.TestID))
          : tempMap;
      }
    }

    //get results that have AllowNonStandardResultValue flag set to true
    let resultsThatAllowNonStandard = this.props.results?.filter((r) => r.AllowNonStandardResultValue);
    resultsThatAllowNonStandard = resultsThatAllowNonStandard?.map((r) => {
      return r.value;
    });

    if (tempIDs && tempIDs?.length === 0) {
      //has no tests
      noTests = true;
    } else if (isDTC && tempMap && tempMap.length > 0) {
      let temp = [];
      for (let i = 0; i < tempMap.length; i++) {
        const tempMapElement = tempMap[i];

        temp.push({
          Test: getLabel(tempMapElement.TestID, this.props.tests).label,
          ResultValue: tempMapElement.ResultValue,
          RelativeAbundance: tempMapElement.RelativeAbundance,
        });
        hasAdditionalResultValue = true;
      }
      testAndResultsArray = temp;
    } else if (tempMap && tempMap?.length === tempIDs?.length) {
      //every test has a result
      let temp = [];
      for (let i = 0; i < tempMap.length; i++) {
        const tempMapElement = tempMap[i];

        if (resultsThatAllowNonStandard.includes(tempMapElement.ResultID)) {
          temp.push({
            Test: getLabel(tempMapElement.TestID, this.props.tests).label,
            Result: getLabel(tempMapElement.ResultID, this.props.results).label,
            ResultValue: tempMapElement.ResultValue,
          });
          hasAdditionalResultValue = true;
        } else {
          temp.push({
            Test: getLabel(tempMapElement.TestID, this.props.tests).label,
            Result: getLabel(tempMapElement.ResultID, this.props.results).label,
          });
        }
      }
      testAndResultsArray = temp;
    } else if (tempIDs && (!tempMap || tempMap?.length === 0) && tempIDs?.length > 0) {
      //has test but no results
      for (let i = 0; i < tempIDs.length; i++) {
        const element = tempIDs[i];
        testAndResultsArray.push({ Test: getLabel(element, this.props.tests).label, Result: 'No Result' });
      }
    } else if (
      tempMap &&
      tempIDs &&
      tempMap?.length > 0 &&
      tempIDs?.length > 0 &&
      tempIDs?.length !== tempMap?.length
    ) {
      //not every test has result
      let temp = [];
      let notIncluded = [];
      for (let i = 0; i < tempMap.length; i++) {
        const tempMapElement = tempMap[i];
        if (resultsThatAllowNonStandard.includes(tempMapElement.ResultID)) {
          temp.push({
            Test: getLabel(tempMapElement.TestID, this.props.tests).label,
            Result: tempMapElement.ResultID ? getLabel(tempMapElement.ResultID, this.props.results).label : 'No Result',
            ResultValue: tempMapElement.ResultValue,
          });
          hasAdditionalResultValue = true;
        } else {
          temp.push({
            Test: getLabel(tempMapElement.TestID, this.props.tests).label,
            Result: tempMapElement.ResultID ? getLabel(tempMapElement.ResultID, this.props.results).label : 'No Result',
          });
        }
      }
      for (let i = 0; i < tempIDs.length; i++) {
        const tempIDsElement = tempIDs[i];
        if (!tempMap.find((t) => t.TestID === tempIDsElement)) {
          notIncluded.push(tempIDsElement);
        }
      }

      for (let i = 0; i < notIncluded.length; i++) {
        const element = notIncluded[i];
        temp.push({ Test: getLabel(element, this.props.tests).label, Result: 'No Result' });
      }

      testAndResultsArray = temp;
    }

    return (
      <>
        <Overlay show_loading={this.state.showLoading} zIndex={100005} />
        <div
          className="modal fade form_modal"
          id={ViewTestInfoModal.ID}
          tabIndex={-1}
          role="dialog"
          aria-label="Test Info"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-body p-0 m-0">
                <div className="container-fluid  min-vh-10">
                  <div className={'row'}>
                    <div className="col-12 pt-2">
                      <div className="card mb-2 text-center">
                        <div className="card-header verlag-bold">
                          <h4 style={{ fontWeight: 'bold' }}>
                            Test Info
                            <button
                              style={{ outline: 'none' }}
                              type="button"
                              className="close pr-4"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true" style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
                                &times;
                              </span>
                            </button>
                          </h4>
                        </div>
                        <div className="card-body">
                          {noTests ? (
                            <div>No Tests Assigned</div>
                          ) : isDTC ? (
                            testAndResultsArray &&
                            testAndResultsArray.length > 0 &&
                            testAndResultsArray.map((t) => (
                              <div className="row">
                                <div className={'col-4 pl-md-0 ml-md-0'}>
                                  <div
                                    className="form-group row"
                                    data-toggle={'tooltip'}
                                    data-placement={'top'}
                                    title={'Test'}
                                  >
                                    <label
                                      id={'Test'}
                                      htmlFor={'Test'}
                                      className="col-12 col-sm-3 col-form-label text-center text-sm-left"
                                    >
                                      {'Test'}
                                    </label>
                                    <div className="col-12 col-sm-8 text-center text-md-left" id={t.Test}>
                                      <input
                                        className="form-control ml-2 ml-md-0"
                                        type={'text'}
                                        name={t.Test}
                                        value={t.Test}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className={'col-4 pl-md-0 ml-md-0'}>
                                  <div
                                    className="form-group row"
                                    data-toggle={'tooltip'}
                                    data-placement={'top'}
                                    title={'Value'}
                                  >
                                    <label
                                      id={'Value'}
                                      htmlFor={'Value'}
                                      className="col-12 col-sm-3 col-form-label text-center text-sm-left"
                                    >
                                      {'DL'}
                                    </label>
                                    <div className="col-12 col-sm-8 text-center text-md-left" id={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}>
                                      <input
                                        className="form-control ml-2 ml-md-0"
                                        type={'text'}
                                        name={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                        value={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className={'col-4 pl-md-0 ml-md-0'}>
                                  <div
                                    className="form-group row"
                                    data-toggle={'tooltip'}
                                    data-placement={'top'}
                                    title={'RA'}
                                  >
                                    <label
                                      id={'RA'}
                                      htmlFor={'RA'}
                                      className="col-12 col-sm-3 col-form-label text-center text-sm-left"
                                    >
                                      {'PP'}
                                    </label>
<div className="col-12 col-sm-8 text-center text-md-left" id={t.RelativeAbundance || t.RelativeAbundance === 0 ? t.RelativeAbundance : ''}>
                                      <input
                                        className="form-control ml-2 ml-md-0"
                                        type={'text'}
                                        name={t.RelativeAbundance || t.RelativeAbundance === 0 ? t.RelativeAbundance : ''}
                                        value={t.RelativeAbundance || t.RelativeAbundance === 0 ? t.RelativeAbundance : ''}
                                        disabled={true}
                                      />
                                    </div>                              
                                </div>
                                </div>
                              </div>
                            ))
                          ) : isEssentialOrComprehensive ? (
                            testAndResultsArray &&
                            testAndResultsArray.length > 0 &&
                            testAndResultsArray.map((t) => (
                              <div className="row">
                                <div className={'col-4 pl-md-0 ml-md-0'}>
                                  {buildRow(
                                    'Test',
                                    <input
                                      className="form-control ml-2 ml-md-0"
                                      type={'text'}
                                      name={t.Test}
                                      value={t.Test}
                                      disabled={true}
                                    />
                                  )}
                                </div>
                                <div className={'col-4 ml-md-0'}>
                                  {buildRow(
                                    'Result',
                                    <input
                                      className="form-control ml-2 ml-md-0"
                                      type={'text'}
                                      name={t.Result || t.Result === 0 ? t.Result : ''}
                                      value={t.Result || t.Result === 0 ? t.Result : ''}
                                      disabled={true}
                                    />
                                  )}
                                </div>
                                <div className={'col-4 ml-md-0'}>
                                  {buildRow(
                                    'Value',
                                    <input
                                      className="form-control ml-2 ml-md-0"
                                      type={'text'}
                                      name={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                      value={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                      disabled={true}
                                    />
                                  )}
                                </div>
                              </div>
                            ))
                          ) : (
                            testAndResultsArray &&
                            testAndResultsArray.length > 0 &&
                            testAndResultsArray.map((t) => (
                              <div className="row">
                                <div
                                  className={
                                    hasAdditionalResultValue ? 'col-4 pl-md-0 ml-md-0' : 'col-5 pl-md-0 ml-md-0'
                                  }
                                >
                                  {buildRow(
                                    'Test',
                                    <input
                                      className="form-control ml-2 ml-md-0"
                                      type={'text'}
                                      name={t.Test}
                                      value={t.Test}
                                      disabled={true}
                                    />
                                  )}
                                </div>
                                <div className={hasAdditionalResultValue ? 'col-4 ml-md-0' : 'col-6 ml-md-0'}>
                                  {buildRow(
                                    'Result',
                                    <input
                                      className="form-control ml-2 ml-md-0"
                                      type={'text'}
                                      name={t.Result ? t.Result : ''}
                                      value={t.Result ? t.Result : ''}
                                      disabled={true}
                                    />
                                  )}
                                </div>

                                {hasAdditionalResultValue && (
                                  <div className="col-4 ml-md-0">
                                    {buildRow(
                                      'Result Value',
                                      <input
                                        className="form-control ml-2 ml-md-0"
                                        type={'text'}
                                        name={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                        value={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                        disabled={true}
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card-footer mb-2 mr-2 ml-0"
                  style={{ backgroundColor: 'transparent', borderTop: 'none' }}
                >
                  {selectedService && selectedService.ReportType >= 3 ? (
                    <button
                      type="button"
                      onClick={() => { this.openPDFNewTab(); }}
                      className={this.props.getResultsButtonBoolean ? 'btn btn-success float-right mb-2' : 'd-none'}
                    >
                      Get Results
                    </button>
                  ) : (
                    <a
                      className={this.props.getResultsButtonBoolean ? '' : 'd-none'}
                      href={
                        this.props.selectedSample
                          ? '/results?fname=' +
                            this.props.selectedSample?.PatientFirstName?.trim() +
                            '&lname=' +
                            this.props.selectedSample?.PatientLastName?.trim() +
                            '&dob=' +
                            this.props.selectedSample?.PatientDOB +
                            '&conf=' +
                            this.props.selectedSample?.ReqNum +
                            '&norecord=true'
                          : ''
                      }
                      target={'_blank'}
                    >
                      <button
                        type="button"
                        className={this.props.getResultsButtonBoolean ? 'btn btn-success float-right mb-2' : 'd-none'}
                      >
                        Get Results
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <RendererPickerModal
          show={this.state.showRendererPicker}
          title="Generate Report"
          options={this.getRendererPickerOptions(selectedService)}
          onClose={() => this.setState({ showRendererPicker: false })}
          onPick={(rendererName) => {
            this.setState({ showRendererPicker: false });
            this.downloadDTCReport(rendererName);
          }}
        />
      </>
    );
  }
}

export default ViewTestInfoModal;
